import CardTable from "components/CardTable/CardTable";
import React, { useEffect } from "react";
import { FillingOrderDateInputs } from "./FillingOrderDateInputs";
import { useDispatch, useSelector } from "react-redux";
import { columns } from "./columns";
import { useSearch } from "hooks/useSearch";
import { CheckBox, Delete, Description } from "@material-ui/icons";
import { ModalV2 } from "components/Modal/ModalV2";
import RegularButton from "components/CustomButtons/Button";
import { deleteFillingOrder } from "redux/actions/fillingOrder/fillingOrderActions";
import { useToggle } from "hooks/useToggle";
import { selectAllPendingFillingOrderDelete } from "redux/actions/fillingOrder/fillingOrderActions";
import { deselectAllPendingFillingOrderDelete } from "redux/actions/fillingOrder/fillingOrderActions";

export const FillingOrderView = () => {
  const dispatch = useDispatch()
  const { isLoadingComp, configTables } = useSelector(({search}) => search)
  const { fillingOrders, fillingOrdersToDelete } = useSelector(({ fillingOrder }) => fillingOrder);
  const [isSelectPending, handleIsSelectPending] = useToggle(true);
  const [isOpenDelete, handleIsOpenDelete] = useToggle();
  const { buildTableConfig, buildCompLoadings } = useSearch();
  const tableKey = "fillingOrder"
  
  const handleDelete = () => {
    dispatch(deleteFillingOrder(fillingOrdersToDelete))
    handleIsOpenDelete()
  }

  const handleSelectPending = () => {
    if(isSelectPending) dispatch(selectAllPendingFillingOrderDelete())
    else dispatch(deselectAllPendingFillingOrderDelete())
    handleIsSelectPending()
  }

  useEffect(() => {
    buildCompLoadings(["loadingFillingOrder"])
    !configTables[tableKey] && buildTableConfig(tableKey);
  }, [])

  return (
    <>
      <CardTable
        title={"Ordenes de Llenado"}
        data={fillingOrders}
        columns={columns}
        hasHeader
        blockBtn
        icon={<Description />}
        isLoading={isLoadingComp?.loadingFillingOrder}
        tableContent={<FillingOrderDateInputs />}
        tableKey={tableKey}
        hasControl
        controls={
          <>
            <RegularButton
              round
              justIcon
              color="danger"
              style={{ margin: 10 }}
              onClick={handleIsOpenDelete}
              tooltip="Eliminar Ordenes"
              disabled={!fillingOrdersToDelete?.length}
            >
              <Delete style={{ margin: 0 }}/>
            </RegularButton>
            <RegularButton
              round
              justIcon
              color={isSelectPending ? "info" : "warning"}
              style={{ margin: 10 }}
              onClick={handleSelectPending}
              tooltip={`${ isSelectPending ? "Seleccionar" : "Deseleccionar" } Pendientes`}
              disabled={!fillingOrders?.length}
            >
              <CheckBox style={{ margin: 0 }}/>
            </RegularButton>
          </>
        }
      />
      <ModalV2
        title={"Estas seguro de eliminar las ordenes?"}
        justConfirm
        open={isOpenDelete}
        onClose={handleIsOpenDelete}
        minHeight={2}
        textAlign="center"
        textMargin={28}
      >
        <RegularButton
          color="transparent"
          onClick={handleIsOpenDelete}
        >
          Cancelar
        </RegularButton>
        <RegularButton
          color="success"
          onClick={handleDelete}
        >
          Confirmar
        </RegularButton>
      </ModalV2>
    </>
  );
};
